import { render, staticRenderFns } from "./vxLogin.vue?vue&type=template&id=58cd9528&scoped=true"
import script from "./vxLogin.vue?vue&type=script&lang=js"
export * from "./vxLogin.vue?vue&type=script&lang=js"
import style0 from "./vxLogin.vue?vue&type=style&index=0&id=58cd9528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd9528",
  null
  
)

export default component.exports